import './momo/style';
import FormStructure from './momo/form_structure';

export default FormStructure;